import React from 'react'
import { get } from 'lodash-es'
import StartEnd from 'syft-acp-util/components/StartEnd'
import { Flex, InfoButton, ToggleTooltip } from '@indeed/ifl-components'
import { AddPerson } from '@indeed/ifl-icons'

const CustomStartEnd = ({ values }) => {
  const isAdhocShift = !!values?.adhoc_shift
  const isAdhocShiftNotApproved = values?.adhoc_shift?.adhoc_shift_approved === 'no_action'
  const adhocShiftStatus = {
    approved: 'Approved',
    no_action: 'Not approved',
    rejected: 'Rejected',
  }[values?.adhoc_shift?.adhoc_shift_approved]

  const label = `Adhoc shift - ${
    isAdhocShiftNotApproved
      ? 'Clock in/out fields are disabled as the adhoc shift is not approved'
      : adhocShiftStatus ?? ''
  }`

  return (
    <Flex sx={{ alignItems: 'center', gap: 2 }}>
      <StartEnd
        values={[values?.startTime, values?.endTime]}
        rowFormat={{ options: { timeZone: get(values, 'timezone') }, noBold: true }}
      />
      {isAdhocShift && (
        <ToggleTooltip label={label}>
          <InfoButton>
            <AddPerson size="sm" aria-hidden />
          </InfoButton>
        </ToggleTooltip>
      )}
    </Flex>
  )
}

export default CustomStartEnd
